import Config from '@configs/Environments';
import { Api } from '@helpers/index';
import useAxios from 'axios-hooks';
import useMockServer from './useMockServer';

// useApi(Config.API_END_POINT);
const path = Config.API_END_POINT + '/entry/facilities/info';


const useAllListData = (powerCustomerLocationNumber:string, timestamp:number): any => {
    const paramsString = useMockServer ? '' : Api.paramsString({
        kyokyuChitenTokuteiNo: powerCustomerLocationNumber,
        timestamp: timestamp
    });

    const [{ data, loading, error }] = useAxios(`${path}${paramsString}`, { useCache: false });

    return { data, loading, error };
};

const useOpenRequestFacility = {
    useAllListData,
};

export default useOpenRequestFacility;